
import { mapActions } from "vuex";
import { Navigation, Manipulation } from "swiper";

const MIN_PRODUCTS_FOR_NAVIGATION = 3;

export default {
  props: {
    products: { type: Array, required: true },
    swiperClass: { type: String, required: true },
  },

  data: () => ({ swiper: null }),

  computed: {
    showNavigation() {
      return this.products.length > MIN_PRODUCTS_FOR_NAVIGATION;
    },
    prevNavClasses() {
      return `${this.swiperClass}-prev left-4 lg:left-8 hidden md:inline-flex -mt-10`;
    },
    nextNavClasses() {
      return `${this.swiperClass}-next right-4 lg:right-8 hidden md:inline-flex -mt-10`;
    },
    swiperOptions() {
      return {
        loop: false,
        slidesPerView: 3,
        slidesPerGroup: 3,
        loopFillGroupWithBlank: false,
        breakpoints: {
          0: {
            slidesPerView: 2.5,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
        modules: [Navigation, Manipulation],
        navigation: {
          nextEl: `.${this.swiperClass}-next`,
          prevEl: `.${this.swiperClass}-prev`,
        },
      };
    },
  },

  watch: {
    products() {
      this.swiper?.update?.();
    },
  },

  async mounted() {
    this.swiper = await this.$swiper.init(
      `.swiper.${this.swiperClass}`,
      this.swiperOptions
    );
  },

  destroyed() {
    this.$swiper.destroy(`.swiper.${this.swiperClass}`);
  },

  methods: {
    ...mapActions("recommendations", ["trackBeacon"]),
  },
};
